<template>
  <div class="profile-component">
    <h5>
      {{ title }}
    </h5>
    <div class="desc" style="white-space: pre-line">
      {{ description }}
    </div>
    <div class="bottom">
      <slot name="bottom"></slot>
    </div>
    <div class="buttons-modify">
      <slot name="buttons"></slot>
    </div>
    <div class="button-action-non-active">
      <slot name="bottom-buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'task',

  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
}
</script>

<style></style>
